import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

import lego from './plugins/lego';

import './assets/style.scss';

Vue.config.productionTip = false;

Vue.use(lego);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
